<template>
<!-- 销售汇总 -->
    <div class="receipt-list-view">
        <!-- 搜索项 -->
        <Row type="flex" align="middle">
            <div class="flex-child">
                <span class="input-label">选择部门</span>
                <span class="Cascader">
                    <Cascader :data="departmentData"
                        v-model="department"
                        @on-change="getCascader"
                        change-on-select></Cascader>
                </span>
            </div>
            <div class="flex-child">
                <span class="input-label">开始日期</span>
                <DatePicker
                    type="date"
                    placeholder="选择日期"
                    :options="options1"
                    v-model="startDate"
                    @on-change="getFormatStartDate">
                </DatePicker>
            </div>
            <div class="flex-child">
                <span class="input-label">结束日期</span>
                <DatePicker
                    type="date"
                    placeholder="选择日期"
                    :options="options2"
                    v-model="endDate"
                    @on-change="getFormatEndDate"></DatePicker>
            </div>
            <div class="flex-child">
                <Checkbox v-model="single">按采购单位过账时间统计</Checkbox>
            </div>
            <!--<div class="flex-child">-->
                <!--<span class="input-label">结算渠道</span>-->
                <!--<Select v-model="settleChannel" style="width:180px;" @on-change="getSettleChannel">-->
                    <!--<Option v-for="item in settleChannelList" :key="item.value" :value="item.value">{{ item.label }}</Option>-->
                <!--</Select>-->
            <!--</div>-->
            <div class="flex-child">
                <span class="input-label">单据状态</span>
                <span>
                    <Select v-model="condis.status" filterable multiple>
                        <Option
                            v-for="item in condisList"
                            :value="item.value"
                            :key="item.value"
                        >
                        {{ item.label }}</Option>
                    </Select>
                </span>
            </div>
            <div class="flex-child">
                <Button type="primary" :loading="checkLoading">
                    <span v-if="!checkLoading" @click="checkList">查询</span>
                    <span v-else>查询...</span>
                </Button>
                <Button :loading="exportLoading">
                    <span v-if="!exportLoading" @click="exportExls">导出</span>
                    <span v-else>正在导出</span>
                </Button>
            </div>
        </Row>
        <Table :columns="columns"
            :data="list"
            :loading="loading"
            id="Elsx-export"
            :height="700">
        </Table>
    </div>
</template>

<script>
import { countSales } from '@/graphql/graphql.js';
import { getMonthFirstDay } from '@/utils/date.js';
import Cookies from 'js-cookie';
import factory from '@/assets/js/ybTool.js';
export default {
    data() {
        const self = this;
        return {
            // 单据列表加载中状态
            loading: false,

            // 查询加载中状态
            checkLoading: false,

            // 导出加载中状态
            exportLoading: false,
            // 部门 && 部门列表
            department: [],
            departmentData: [],
            columns: [
                {
                    title: '序号',
                    key: 'serialNum'
                },
                {
                    title: '部门',
                    key: 'organName'
                },
                {
                    title: '部门编码',
                    key: 'organNo'
                },
                {
                    title: '数量',
                    key: 'totalCount'
                },
                {
                    title: '金额',
                    key: 'totalAmount'
                }
            ],
            condisList: [
                {
                    value: 1,
                    label: '正常'
                },
                {
                    value: 0,
                    label: '作废'
                }
            ],
            single: false,
            timeOut: null,
            condis: {
                organNo: '',
                startTime: getMonthFirstDay(),
                endTime: getMonthFirstDay(new Date().getDate()),
                status: [],
                isPost: 0
            },
            startDate: getMonthFirstDay(),
            endDate: getMonthFirstDay(new Date().getDate()),
            options1: {
                disabledDate(date) {
                    return date && date.valueOf() > Date.now();
                }
            },
            options2: {
                disabledDate(date) {
                    return date && date.valueOf() < self.getTimeBegin();
                }
            },
            list: [],
            userInfo: Cookies.getJSON('USER-INFO') || '',
            settleChannelList: [],
            settleChannel: 'D00'
        };
    },
    mounted() {
        this.getAllOrganList();
        this.getSales();
    },
    methods: {
        // 获取列表
        getSales() {
            this.condis.isPost = this.single ? 1 : 0;
            this.$apollo.query({
                query: countSales,
                variables: {
                    condi: this.condis,
                    supplierNo: this.userInfo.supplierNo,
                    cliqueNo: `${Cookies.getJSON('cliqueNo')}`
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.countSales;
                if (data && data.code === 200) {
                    this.checkLoading = false;
                    if (data.data.length <= 1) {
                        this.list = [];
                    } else {
                        this.list = data.data;
                    }
                }
            });
        },
        // 获取部门列表
        async getAllOrganList() {
            if (this.$store.state.organs.length) {
                this.departmentData = this.$store.state.organs;
                clearTimeout(this.timeOut);
            } else {
                clearTimeout(this.timeOut);
                this.timeOut = setTimeout(() => {
                    this.getAllOrganList();
                }, 3000);
            }
        },

        // 选中部门
        getCascader(val) {
            this.condis.organNo = val[val.length - 1] || '';
        },

        // 获取格式化日期 && 开始日期
        getFormatStartDate(date) {
            this.condis.startTime = date;
        },
        // 结束日期
        getFormatEndDate(date) {
            this.condis.endTime = date;
        },
        // data 中 option2 调用
        getTimeBegin() {
            return Date.parse(this.startDate);
        },
        // 查询
        checkList() {
            this.checkLoading = true;
            this.getSales();
        },
        // 导出
        exportExls() {
            if (this.list.length) {
                this.exportLoading = true;
                document.querySelector('#Elsx-export .ivu-table-tip tbody td span').innerText = ' ';
                factory().excelExport({
                    'src_id': 'Elsx-export',
                    'type': 'table',
                    'show_header': true
                }, '销售情况汇总统计');
                setTimeout(() => {
                    this.exportLoading = false;
                }, 2000);
            }
        },
        getSettleChannel(val) {
            if (val === 'D00') {
                this.condis.settleChannel = '';
            } else {
                this.condis.settleChannel = val;
            }
        }
    }
};
</script>
<style scoped lang="stylus">

@import '../assets/stylus/views/receipt-list.styl'

</style>



// WEBPACK FOOTER //
// src/views/SalesStatistics.vue